import * as ROUTES from './routes';

export const WITHDRAW_ROUTES = Object.values(ROUTES);
